import React from "react";
import linkedinIcon from "../../../assets/Team/mobile/index.png";
import twitterIcon from "../../../assets/Team/mobile/x.png";
import { profile, Advisors } from "./Profile";
import styles from "./Team.module.css";
import clsx from "clsx";

const TeamMembers = ({ photo, name, title, linkedin, twitter, des }) => {
  return <div className={styles["team-member-wrapper"]}>
    <div className={clsx(styles["card-team"], styles["card-container"],"m-auto")}>
      <img className={styles["team-member-image"]}
        src={photo}
        alt={name}
      />
      <div className={styles["card-body"]}>
        <div className="row">
          <div className="col-9">
            <div className={styles["cardTitle"]}> {name} </div>
            <div className={styles["cardText"]}> {title} </div>
          </div>
          <div className="col-3">
            <span className="float-right">
              {linkedin && (
                <a href={linkedin} target="_blank" rel="noreferrer">
                  <img
                    src={linkedinIcon}
                    alt="linkedin icon"
                    width="35px"
                    className="pt-2 mr-2"
                  />
                </a>
              )}
              {twitter && (
                <a href={twitter} target="_blank" rel="noreferrer">
                  <img
                    src={twitterIcon}
                    alt="linkedin icon"
                    width="35px"
                    className="pt-2"
                  />
                </a>
              )}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>;
};

const TeamFlipCard = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div>
        <div className={clsx(styles["teamHeader-card"], "globalHeaderBgS")}>
          <div className="container">
            <h1 className={styles["meetteam"]}>
              MEET THE TEAM
            </h1>
          </div>
        </div>
        <div className="container" >
          <div className="row">
            {profile.map((profile, index) => (
              <div key={index} className="col-lg-6 col-md-4 col-sm-12 p-0">
                <TeamMembers
                  photo={profile.photo}
                  name={profile.name}
                  title={profile.title}
                  linkedin={profile.linkedin}
                  twitter={profile.twitter}
                  des={profile.des}
                />
              </div>
            ))}
          </div>
        </div>
        <div className="container">
          <h1 className={styles["meetteam_2"]}>
            Advisors
          </h1>
        </div>
        <div className="container" >
          <div className="row">
            {Advisors.map((profile, index) => (
              <div key={index} className="col-lg-6 col-md-4 col-sm-12 p-0">
                <TeamMembers
                  photo={profile.photo}
                  name={profile.name}
                  title={profile.title}
                  linkedin={profile.linkedin}
                  twitter={profile.twitter}
                  des={profile.des}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default TeamFlipCard;